<div class="auth-page">

<div class="background-slideshow">
    <div
        *ngFor="let image of images; let i = index"
        class="background-slide"
        [style.background-image]="'url(' + image + ')'"
        [class.active]="i === activeIndex">
    </div>
</div>

<div class="auth-container">
    <div class="auth-left">

        <!-- NEBULAR ERROR MESSAGES -->
        <div *ngIf="showMessages?.error && errors?.length && !submitted" class="alert alert-danger custom-alert">
            <ul>
                <li *ngFor="let err of errors">{{ err }}</li>
            </ul>
        </div>

        <!-- NEBULAR SUCCESS MESSAGES -->
        <div *ngIf="showMessages?.success && messages?.length && !submitted" class="alert alert-success custom-alert">
            <ul>
                <li *ngFor="let msg of messages">{{ msg }}</li>
            </ul>
        </div>

        <div class="auth-header">
            <h2>Create Your Account</h2>
            <p>Fill in your details to get started</p>
        </div>

        <form class="auth-form" (ngSubmit)="register()" #registerForm="ngForm">

            <div class="form-group name-fields">
                <div>
                    <label class="form-label">First Name</label>
                    <input
                        type="text"
                        class="form-input"
                        name="firstName"
                        [(ngModel)]="user.firstName"
                        placeholder="First name"
                        required>
                </div>

                <div>
                    <label class="form-label">Last Name</label>
                    <input
                        type="text"
                        class="form-input"
                        name="lastName"
                        [(ngModel)]="user.lastName"
                        placeholder="Last name"
                        required>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Email Address</label>
                <input
                    type="email"
                    class="form-input"
                    name="email"
                    [(ngModel)]="user.email"
                    placeholder="Enter your email"
                    required>
            </div>

            <div class="form-group">
                <label class="form-label">Password</label>
                <div class="password-input">
                    <input
                        [type]="showPassword ? 'text' : 'password'"
                        class="form-input"
                        name="password"
                        [(ngModel)]="user.password"
                        placeholder="Create a password"
                        required>
                    <button type="button" class="toggle-password" (click)="togglePassword()">

                        <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Confirm Password</label>
                <div class="password-input">
                    <input
                        [type]="showConfirmPassword ? 'text' : 'password'"
                        class="form-input"
                        name="confirmPassword"
                        [(ngModel)]="user.confirmPassword"
                        placeholder="Confirm your password"
                        required>
                    <button type="button" class="toggle-password" (click)="toggleConfirmPassword()">
                        <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                </div>

                <p *ngIf="user.password && user.confirmPassword && user.password !== user.confirmPassword"
                    class="caption status-danger">
                    Passwords do not match
                </p>
            </div>

            <div class="terms">
                <input
                    type="checkbox"
                    id="terms"
                    name="terms"
                    [(ngModel)]="user.terms"
                    required>
                <label for="terms">
                    I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
                </label>
            </div>

            <button
                type="submit"
                class="btn"
                [disabled]="submitted">
                <span *ngIf="!submitted">Create Account</span>
                <span *ngIf="submitted">
                    <i class="fas fa-spinner fa-spin"></i> Creating Account...
                </span>
            </button>

            <div class="auth-footer">
                Already have an account?
                <a (click)="router.navigate(['/auth/login'])" class="login-link">Sign in</a>
            </div>
        </form>
    </div>

<div class="auth-right">
  <div class="auth-right-inner">

    <!-- Logo -->
    <div class="logo">
      <img src="assets/images/logoDS.png" alt="Portus ERP">
    </div>

    <!-- Corporate Headline -->
    <!-- <div class="auth-message">

      <p class="tagline">
        Enterprise Platform for Freight & Logistics Operations
      </p>
    </div> -->

    <!-- Value points -->
    <!-- <ul class="auth-points">
      <li>Unified Freight, Accounts & Operations</li>
      <li>Role-based Access & Approval Flow</li>
      <li>Real-time Reporting & Job P&L</li>
      <li>Secure Cloud Infrastructure</li>
    </ul> -->

    <!-- Footer note -->
    <div class="auth-footer-note">
      © 2025 Portus · All rights reserved
    </div>




  </div>
</div>
<!--
              <button class="theme-toggle" (click)="toggleTheme()">
                  <i [class]="isDark ? 'fas fa-sun' : 'fas fa-moon'"></i>
              </button> -->
</div>
</div>
